import React, { Fragment, useState, useEffect } from 'react';
import validator from 'validator';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Box, Dialog } from '@mui/material';
import styled from '@emotion/styled';

import { UsStates } from 'utils/constants';
import { setDataAction } from 'store/actions/claimFormActions';
import { getLandlordDisplayName } from 'components/ClaimForm/helpers';
import GoogleAutoComplete from 'components/ClaimForm/GoogleAutoComplete';
import { loadGoogleMaps } from 'utils/loadGoogleMaps';

import { Input, Button, IconGraphy, Dropdown, Typography, colors } from '@leapeasy/ui-kit';

import Img_Alert from 'assets/alert.png';

const Form2 = (props) => {
  const { actions, token, formData, handleNext, handleBack } = props;

  const [paymentMethod, setPaymentMethod] = useState(null);

  const [data, setFormData] = useState({
    payee: null,
    payeeEmail: null,
    receiptPayee: null,
    receiptEmail: null,
    address1: null,
    // address2: null,
    city: null,
    state: null,
    zipCode: null,
    paymentMethod: null,
  });

  // useState(() => {
  //   let selectedLL = formData.landlordArray.filter((ll) => ll.Landlord__c === formData.data.landlord)[0];
  //   setFormData({...formData, receiptEmail: selectedLL.Email_Address__c})
  // }, [])

  const [valid, setValid] = useState({
    // payee: true,
    // email: true,
  });

  let disable = true;

  const [isLandlordEmail, setIsLandlordEmail] = useState(false);
  const [flgLL, setFlgLL] = useState(false);
  const [mapsLoadState, setMapsLoadState] = useState('idle');

  // useEffect(() => {
  //   let landlords = formData.landlordArray;
  //   let selectedLandlord = landlords.filter((item) => item.Landlord__c === formData.data.landlord)[0]
  //   if (selectedLandlord && selectedLandlord.Email_Address__c === null) {
  //     setIsLandlordEmail(true);
  //   } else {
  //     setFlgLL(true)
  //     actions.setDataAction({
  //       ...formData.data,
  //       receiptEmail: data.receiptEmail,
  //     });
  //   }
  // }, [])

  useEffect(() => {
    // for enhancement
    setFormData({
      // ACH start
      payee: formData.data.payee,
      payeeEmail: formData.data.payeeEmail,
      // ACH End
      // echeck start
      receiptPayee: formData.data.receiptPayee,
      receiptEmail: formData.data.receiptEmail,
      // echeck End
      // Physical Start
      physicalName: formData.data.physicalName,
      physicalEmail: formData.data.physicalEmail,
      address1: formData.data.address1,
      // address2: formData.data.address2,
      city: formData.data.currentCity,
      state: formData.data.currentState,
      zipCode: formData.data.currentZipCode,
      paymentMethod: formData.data.paymentMethod,
      // Physical End
    });
    setValid({
      payeeEmail: formData.data.payeeEmail ? validator.isEmail(formData.data.payeeEmail) : false,
      receiptEmail: formData.data.receiptEmail
        ? validator.isEmail(formData.data.receiptEmail)
        : false,
      physicalEmail: formData.data.physicalEmail
        ? validator.isEmail(formData.data.physicalEmail)
        : false,
    });

    const selectedLL = formData.landlordArray?.find(
      (ll) => ll.Landlord__c === formData.data.landlord,
    );
    if (!selectedLL) {
      return;
    }

    const landlordName = getLandlordDisplayName(selectedLL);
    const landlordEmail =
      selectedLL.Landlord__r?.Email_Address__c || selectedLL.Landlord__r_Email_Address__c;

    if (landlordName === 'The Cardinal Group') {
      setFormData({ ...formData, receiptEmail: 'accounting@cardinalgroup.com' });
      setValid({ ...valid, receiptEmail: validator.isEmail('accounting@cardinalgroup.com') });
    } else if (landlordEmail) {
      setFormData({ ...formData, receiptEmail: landlordEmail });
      setValid({ ...valid, receiptEmail: validator.isEmail(landlordEmail) });
    }
  }, [formData]);

  useEffect(() => {
    if (data.paymentMethod !== 'physical_check') {
      setMapsLoadState('idle');
      return undefined;
    }

    let cancelled = false;
    setMapsLoadState('loading');

    loadGoogleMaps()
      .then(() => {
        if (!cancelled) setMapsLoadState('ready');
      })
      .catch(() => {
        if (!cancelled) setMapsLoadState('error');
      });

    return () => {
      cancelled = true;
    };
  }, [data.paymentMethod]);

  const handleChange = (e, label) => {
    const value = e.target.value;
    setFormData({ ...data, [label]: value });
    if (label === 'payeeEmail') {
      setValid({ ...valid, payeeEmail: validator.isEmail(value) });
    }
    if (label === 'receiptEmail') {
      setValid({ ...valid, receiptEmail: validator.isEmail(value) });
    }
    if (label === 'physicalEmail') {
      setValid({ ...valid, physicalEmail: validator.isEmail(value) });
    }
  };

  const handleAddress = (value) => {
    const { short_name: state = '' } =
      value.address_components.find((c) => c.types.includes('administrative_area_level_1')) || {};
    const { short_name: city = '' } =
      value.address_components.find((c) => c.types.includes('locality')) || {};
    const { short_name: streetNumber = '' } =
      value.address_components.find((c) => c.types.includes('street_number')) || {};
    const { short_name: route = '' } =
      value.address_components.find((c) => c.types.includes('route')) || {};
    const { long_name: postalCode = '' } =
      value.address_components.find((c) => c.types.includes('postal_code')) || {};
    setFormData({
      ...data,
      address1: streetNumber + ' ' + route,
      city: city,
      state: state,
      zipCode: postalCode,
    });
  };

  const handleNextButton = () => {
    actions.setDataAction({
      ...formData.data,
      paymentMethod: data.paymentMethod,
      payee: data.payee,
      payeeEmail: data.payeeEmail,
      receiptPayee: data.receiptPayee,
      receiptEmail: data.receiptEmail,
      physicalName: data.physicalName,
      physicalEmail: data.physicalEmail,
      address1: data.address1,
      // address2: data.address2,
      currentCity: data.city,
      currentState: data.state,
      currentZipCode: data.zipCode,
      paymentMethod: data.paymentMethod,
    });
    handleNext();
  };

  if (
    // data.payee &&
    // data.payeeEmail &&
    // valid.receiptPayee &&
    // valid.receiptEmail &&
    // data.address1 &&
    // data.address2 &&
    // data.city &&
    // data.state &&
    // data.zipCode &&
    // data.paymentMethod &&
    data.paymentMethod &&
    (data.paymentMethod === 'eCheck'
      ? data.receiptPayee && data.receiptEmail && valid.receiptEmail
      : true) &&
    (data.paymentMethod === 'physical_check'
      ? data.physicalName &&
        valid.physicalEmail &&
        data.physicalEmail &&
        data.address1 &&
        // data.address2 &&
        data.city &&
        data.state &&
        data.zipCode
      : true) &&
    (data.paymentMethod === 'ACH' ? data.payee && data.payeeEmail && valid.payeeEmail : true)
  ) {
    disable = false;
  } else {
    disable = true;
  }

  return (
    <Box sx={{ px: 2 }}>
      <Dialog open={isLandlordEmail}>
        <Box style={{ borderRadius: '8px', padding: '20px' }}>
          <Typography variant="body1" style={{ color: colors.purple[900], fontSize: '20px' }}>
            This company email is not registered in SF.
          </Typography>
          <Button style={{ marginTop: '20px' }} onClick={() => setIsLandlordEmail(false)}>
            Ok
          </Button>
        </Box>
      </Dialog>
      <Box display="flex" flexDirection="column" gap="20px">
        <Typography variant="body1" style={{ color: colors.purple[900], fontSize: '20px' }}>
          Payment Method
        </Typography>
        <Dropdown
          value={data.paymentMethod}
          size="medium"
          onChange={(e) => handleChange(e, 'paymentMethod')}
          options={[
            {
              text: 'eCheck - fastest',
              value: 'eCheck',
            },
            {
              text: 'Mailed Physical Check',
              value: 'physical_check',
            },
          ]}
          showSearch={false}
          label="Payment method"
          iconVisible={false}
          style={{
            minWidth: '100%',
          }}
        />
        {data.paymentMethod === 'eCheck' && (
          <React.Fragment>
            <Input
              value={data.receiptPayee}
              onChange={(e) => handleChange(e, 'receiptPayee')}
              label="Who Does The Check Need To Be Issued To?"
              icon={<IconGraphy icon="Users.User" style={{ width: 16, height: 16 }} />}
              minWidth="100%"
              fullWidth
              size="medium"
            />
            <Input
              value={data.receiptEmail}
              onChange={(e) => handleChange(e, 'receiptEmail')}
              label="Check receipt email."
              icon={<IconGraphy icon="Users.User" style={{ width: 16, height: 16 }} />}
              minWidth="100%"
              fullWidth
              size="medium"
              showCopy={false}
              errorType={!valid.receiptEmail && data.receiptEmail ? 'error' : 'none'}
              helperMessage={
                !valid.receiptEmail && data.receiptEmail
                  ? 'Invalid Input'
                  : 'Please provide a company email'
              }
            />
          </React.Fragment>
        )}
        {data.paymentMethod === 'physical_check' && (
          <React.Fragment>
            <Input
              value={data.physicalName}
              onChange={(e) => handleChange(e, 'physicalName')}
              label="Who Does The Check Need To Be Issued To?"
              icon={<IconGraphy icon="Users.User" style={{ width: 16, height: 16 }} />}
              minWidth="100%"
              fullWidth
              size="medium"
            />
            <Input
              value={data.physicalEmail}
              onChange={(e) => handleChange(e, 'physicalEmail')}
              label="Check Receipt email"
              icon={<IconGraphy icon="Users.User" style={{ width: 16, height: 16 }} />}
              minWidth="100%"
              fullWidth
              size="medium"
              showCopy={false}
              errorType={!valid.physicalEmail && data.physicalEmail ? 'error' : 'none'}
              helperMessage={
                !valid.physicalEmail && data.physicalEmail
                  ? 'Invalid Input'
                  : 'Please provide a company email'
              }
            />
            <Box mb={2}>
              {mapsLoadState === 'ready' ? (
                <GoogleAutoComplete
                  address1={data.address1}
                  handleAddress={(value) => handleAddress(value)}
                />
              ) : (
                <Input
                  value={data.address1 || ''}
                  onChange={(e) => handleChange(e, 'address1')}
                  label="Address Line 1"
                  placeholder="Address Line 1"
                  icon={<IconGraphy icon="MapTravel.EditLocationAlt" />}
                  minWidth="100%"
                  fullWidth
                  size="medium"
                  showCopy={false}
                  helperMessage={
                    mapsLoadState === 'loading'
                      ? 'Loading address search...'
                      : 'Enter your mailing address manually'
                  }
                />
              )}
            </Box>
            {/* <Input
                value={data.address2}
                onChange={(e) => handleChange(e, 'address2')}
                label="Address Line 2"
                placeholder="Address Line 2"
                icon={<IconGraphy icon="MapTravel.Place" />}
                minWidth="100%"
                fullWidth
                size="medium"
                showCopy={false}
              /> */}

            <Input
              value={data.city}
              onChange={(e) => handleChange(e, 'city')}
              label="City"
              placeholder="City"
              icon={<IconGraphy icon="MapTravel.PinDrop" />}
              minWidth="100%"
              fullWidth
              size="medium"
              showCopy={false}
            />

            <Dropdown
              value={data.state}
              size="medium"
              onChange={(e) => handleChange(e, 'state')}
              options={(UsStates || []).map((state) => ({
                text: state.abbreviation,
                value: state.abbreviation,
              }))}
              multiselect={false}
              label="State"
              showSearch={true}
              icon={<IconGraphy icon="MapTravel.Map" />}
              iconVisible
              style={{
                minWidth: '100%',
              }}
            />

            <Input
              value={data.zipCode}
              onChange={(e) => handleChange(e, 'zipCode')}
              label="Zip Code"
              placeholder="Zip Code"
              icon={<IconGraphy icon="MapTravel.PostOffice" />}
              minWidth="100%"
              fullWidth
              size="medium"
              showCopy={false}
            />
          </React.Fragment>
        )}
        {data.paymentMethod === 'ACH' && (
          <React.Fragment>
            <Input
              value={data.payee}
              onChange={(e) => handleChange(e, 'payee')}
              label="Who Does The Check Need To Be Issued To?"
              icon={<IconGraphy icon="Users.User" style={{ width: 16, height: 16 }} />}
              minWidth="100%"
              fullWidth
              size="medium"
              showCopy={false}
              showHelperMessage={false}
            />

            <Input
              value={data.payeeEmail}
              onChange={(e) => handleChange(e, 'payeeEmail')}
              label="Payment Reciept Email"
              icon={<IconGraphy icon="Users.User" style={{ width: 16, height: 16 }} />}
              minWidth="100%"
              fullWidth
              size="medium"
              showCopy={false}
              errorType={!valid.payeeEmail && data.payeeEmail ? 'error' : 'none'}
              helperMessage={
                !valid.payeeEmail && data.payeeEmail
                  ? 'Invalid Input'
                  : 'Please provide a company email'
              }
            />
          </React.Fragment>
        )}
      </Box>

      <Box
        sx={{ display: 'flex', justifyContent: 'center', flexDirection: 'row', mt: 4, gap: '16px' }}
      >
        <Button size="medium" variant="secondary" onClick={handleBack} style={{ flexShrink: 2 }}>
          Back
        </Button>

        <Button size="medium" variant="primary" onClick={handleNextButton} disabled={disable}>
          <Typography variant="body1">Next</Typography>
        </Button>
      </Box>
      {data.paymentMethod === 'physical_check' && (
        <Box marginTop="24px">
          <Box
            backgroundColor="#E8F1FE"
            borderRadius="8px"
            padding="12px"
            display="flex"
            justifyContent="flex-start"
            alignItems="flex-start"
            gap="10px"
          >
            <Box>
              <img src={Img_Alert} alt="alert" />
            </Box>

            <Box flex={1} color="#175EC2" fontSize="13px" fontWeight="400">
              <Box fontWeight="600" color="#175EC2">
                Important Notice!
              </Box>
              You selected “physical check” as the preferred method of payment for this claim,
              correct? Note: This confirmation of payment method preference does not guarantee
              approval or payment of any claim.
            </Box>
          </Box>
        </Box>
      )}

      {data.paymentMethod === 'eCheck' && (
        <Box marginTop="24px">
          <Box
            backgroundColor="#E8F1FE"
            borderRadius="8px"
            padding="12px"
            display="flex"
            justifyContent="flex-start"
            alignItems="flex-start"
            gap="10px"
          >
            <Box>
              <img src={Img_Alert} alt="alert" />
            </Box>

            <Box flex={1} color="#175EC2" fontSize="13px" fontWeight="400">
              <Box fontWeight="600" color="#175EC2">
                Important Notice!
              </Box>
              E-Check is the fastest payment method
            </Box>
          </Box>
        </Box>
      )}
    </Box>
  );
};

const mapStateToProps = (state) => {
  return {
    formData: state.getIn(['formData']),
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    actions: bindActionCreators(
      {
        setDataAction,
      },
      dispatch,
    ),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Form2);
